













import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetPACSInfo} from '../../api/realTime'
@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    created(){
        this.getData()
    }
    get height(){
        return window.innerHeight-220
    }
    async getData(){
        let res = await GetPACSInfo({patientId:this.id})
        this.list = res.data
    }
    detailShow = false
    detailData = {}
    list = []
    columns = [
        {title:'申请日期',key:'applyDate'},
        {title:'诊断日期',key:'reportDate'},
        {title:'诊断医院',key:'hosptialName'},
        {title:'诊断内容',key:'checkResult'},
    ]
}
